/* import __COLOCATED_TEMPLATE__ from './menu.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { MenuItemWithParent } from 'volta/services/app-nav-state';

interface BvAppSearchEntryMenuSignature {
  Args: {
    menu: MenuItemWithParent;
  };
}

const BvAppSearchEntryMenuComponent = templateOnlyComponent<BvAppSearchEntryMenuSignature>();

export default BvAppSearchEntryMenuComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::Menu': typeof BvAppSearchEntryMenuComponent;
    'bv-app-search/entry/menu': typeof BvAppSearchEntryMenuComponent;
  }
}
